import { NgModule, APP_INITIALIZER, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// ngx-bootstrap modules
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { AppRoutingModule } from '@src/app/app-routing.module';
import { AppComponent } from '@src/app/app.component';
import { HomeComponent } from '@src/app/home/home.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { API_BASE_URL } from '@src/app/service-proxies';
import { AppConsts } from '@src/app/shared/AppConsts';
import { AppConfigService } from '@src/app/shared/app-config.service';
import { HeaderComponent } from '@src/app/header/header.component';
import { FooterComponent } from '@src/app/footer/footer.component';
import { AuthGuard } from '@src/app/shared/guards/auth-guard.service';
import { MainSliderComponent } from '@src/app/main-slider/main-slider.component';
import { AccountLayoutComponent } from '@src/app/account-layout.component';
import { MainLayoutComponent } from '@src/app/main-layout.component';
import { AccountGuard } from '@src/app/shared/guards/account-guard.service';
import { AlertService } from '@src/app/shared/alert.service';

// import { ToastrModule, ToastrService, IndividualConfig } from 'ngx-toastr';
import { NotyfModule } from 'ng-notyf';

import {EditorModule} from 'primeng/editor';
import {FileUploadModule} from 'primeng/fileupload';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilsModule } from '@src/app/shared/utils/utils.module';
import { httpInterceptors } from '@src/app/shared/index';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateLanguageLoader, AppTranslationService } from '@src/app/shared/app-translation.service';
import { NgxSpinnerModule, NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';
import { GuestQuestionComponent } from '@src/app/guest-question/guest-question.component';
// import { NotificationService } from '@src/app/shared/utils/notification.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { LoaderComponent } from '@src/app/shared/loader/loader.component';
import { LoaderService } from './shared/loader/loader.service';
import { LoaderInterceptor } from './shared/loader/loader.interceptor';
import { ModalModule } from 'ngx-bootstrap';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { VideoComponent } from './Videolayoutcomponent';
import { PrivacyPolicyComponent } from './privacyPolicy.component';

export function getBaseUrl(): string {
  return AppConsts.apiBaseUrl;
}

export function appInit(appConfigService: AppConfigService) {
  return () =>
    appConfigService.load().then(data => {
      AppConsts.apiBaseUrl = data.apiBaseUrl;
      AppConsts.fileUploadUrl = data.uploadFileUrl;
      AppConsts.fileDownloadUrl = data.downloadFileUrl;
      AppConsts.uploadProfilePicUrl = data.uploadProfilePicUrl;
    });
}

// const toastrService = {
//   success: (message?: string, title?: string, override?: Partial<IndividualConfig>) => {},
//   error: (message?: string, title?: string, override?: Partial<IndividualConfig>) => {}
// };

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AccountLayoutComponent,
    MainLayoutComponent,
    MainSliderComponent,
    GuestQuestionComponent,
    LoaderComponent,
    VideoPlayerComponent,
    VideoComponent,
    PrivacyPolicyComponent
  
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: TranslateLanguageLoader
            }
        }),
     //ToastrModule.forRoot({positionClass: 'toast-bottom-right'}),
    NotyfModule,
    ReactiveFormsModule,
    HttpClientModule,
    UtilsModule,
    EditorModule,
    FileUploadModule,
    TabsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    SlickCarouselModule,
    
  ],
  providers: [
    // {provide: ToastrService, useValue: toastrService},
    LoaderService,
    AppConfigService,
    AppTranslationService,
    AuthGuard,
    AccountGuard,
    AlertService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [AppConfigService]
    },
    {
      provide: API_BASE_URL,
      useFactory: getBaseUrl
    },
    httpInterceptors
    ],
    bootstrap: [AppComponent],
    entryComponents: [NgxSpinnerComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    

})
export class AppModule { }
